import {useFreightContext} from 'components/customer/Confirmation/Freight';
import {Depot} from 'components/customer/Confirmation/Freight/Depots/Depot';
import React, {useMemo, useState} from 'react';
import {useMediaQuery} from 'react-responsive';
import {createMediaQuery, size} from 'shared/Breakpoints';
import styled from 'styled-components';

// stack depots on tablets in portrait and anything narrower than a tablet.
// sit side by side on tablets in landscape and bigger
const STACKED_QUERY = `(pointer: coarse) and (orientation: portrait), (max-width: ${
    size.md - 1
}px)`;
const stacked = createMediaQuery(STACKED_QUERY);

export const Depots = () => {
    const {depots, isLoadingDepots, selectedDepot} = useFreightContext();
    const hasChoice = depots && depots.length > 1;
    const [pinnedDepotId, setPinnedDepotId] = useState<number>();
    const isStacked = useMediaQuery({query: STACKED_QUERY});

    if (selectedDepot && typeof pinnedDepotId === 'undefined' && isStacked) {
        setPinnedDepotId(selectedDepot.id);
    }

    const sortedDepots = useMemo(() => {
        if (!depots || typeof pinnedDepotId === 'undefined') {
            return depots;
        }

        return [...depots].sort(
            (a, b) =>
                Number(b.id == pinnedDepotId) - Number(a.id == pinnedDepotId)
        );
    }, [depots, pinnedDepotId]);

    if (isLoadingDepots) {
        return <>Loading...</>;
    }

    if (sortedDepots && sortedDepots.length && hasChoice) {
        return (
            <>
                <Title>Select a depot</Title>
                <Container>
                    {sortedDepots.map((depot) => {
                        return <Depot key={depot.id} depot={depot} />;
                    })}
                </Container>
            </>
        );
    }
};

const Title = styled.h2`
    color: ${({theme}) => theme.colors.primary?.main};
    text-align: left;
    font-weight: bold;
    font-size: 1em;
    background: none !important;
    margin-bottom: 0;
    padding: 0 !important;
`;

const Container = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 15px;
    flex-wrap: wrap;

    ${stacked`
        flex-direction: column;
    `}
`;
